import * as React from 'react';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

import { Background, LogoWrapper, Spacer } from './styled';
import { getLogoForBrand } from './supported-brands';

interface IBrandInfoProps {
  brandId: string;
  brandUrl: string;
}

export const BrandLogo: React.FC<IBrandInfoProps> = ({ brandId, brandUrl }) => {
  const newPdDesign = useNewPdDesignEnabled();
  const logo = getLogoForBrand(brandId);

  if (!logo) {
    return newPdDesign ? null : <Spacer />;
  }

  return (
    <LogoWrapper>
      <Background href={brandUrl}>{logo}</Background>
    </LogoWrapper>
  );
};
